import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const StyledRedemptionButton = makeUclComponent(ActionButton).withConfig({
  fontSize: 'lg',
  justifyContent: 'center',
  height: '48px',
});
